import facepaint from 'facepaint';
import { mediaQueries } from '../../constants';
var small = mediaQueries[0],
    medium = mediaQueries[1],
    large = mediaQueries[2],
    xlarge = mediaQueries[3],
    xxlarge = mediaQueries[4];
export var breakpoints = {
  small: small,
  medium: medium,
  large: large,
  xlarge: xlarge,
  xxlarge: xxlarge
};
export var facepaintMediaQueries = facepaint(mediaQueries);